export default {
  id: "papa-johns-revenge",
  pride: 26624,
  slug: "papa-johns-revenge",
  category: "game",
  status: "released",
  experienceable: true,
  titleKey: {
    zh: "骸骨船长的复仇",
    en: "Papa John's Revenge"
  },
  image: "https://img.itch.zone/aW1nLzUxMTA2MDkuanBn/315x250%23c/jyaoNZ.jpg",
  date: { year: 2021, month: 1 },
  descriptionKey: {
    zh: "帕帕·约翰船长无比想念自己的身体，决定复活自己，为之死复仇。GGJ 2021 合作解谜游戏，主题 Lost and Found（丢失与找回）。三关流程——从一颗头骨出发，收集骨头组回脊髓和完整骨架，解锁新能力后才能闯过最终关。",
    en: "Captain Papa John misses his body sooo much so he decides to revive himself and revenge for his death. GGJ 2021 collab puzzle game, theme: Lost and Found. Three levels — start as a lone skull, collect bones to build a spine then a full skeleton, each unlocking new movement abilities to reach the finale."
  },
  genres: ["解谜", "平台", "Game Jam"],
  themes: ["海盗", "骷髅"],
  developerNotesKey: {
    zh: "GGJ 2021 全球游戏制作节合作作品，主题 Lost and Found（丢失与找回）。品质相当不错的三关解谜平台游戏。",
    en: "GGJ 2021 Global Game Jam collab, theme: Lost and Found. A surprisingly polished three-level puzzle platformer."
  },
  tags: ["Game Jam"],
  longDescriptionKey: {
    zh: "",
    en: ""
  },
  links: [
    { type: "itch", url: "https://ws-studio.itch.io/papa-johns-revenge", textKey: { zh: "itch.io 游玩", en: "Play on itch.io" } }
  ]
};
